import React, { Component } from "react";
import {
    Image,
    List,
    Grid,
    Button,
    Icon,
    Label,
    Divider,
} from "semantic-ui-react";
import axios from "axios";
import "./main.css";
import jwt from "jsonwebtoken";

const { API } = require("../../global/constants");

// main Child component to render list item
export default class MemeItem extends Component {
    state = {
        likes: this.props.meme.likes.length,
        delete: false,
        liked: false,
        owner: false,
    };

    async componentDidMount() {
        let user_id;
        try {
            const token = localStorage.getItem("authToken");
            user_id = jwt.verify(token, process.env.REACT_APP_JWT_SECRET).id;
        } catch (error) {
            console.log("environemnt variable not defined");
        }
        if (user_id === this.props.meme.user) {
            this.setState({ owner: true });
        }
        let flag = false;
        for (let like of this.props.meme.likes) {
            if (like === user_id) {
                flag = true;
                this.setState({ liked: true });
                break;
            }
        }
        if (!flag) {
            this.setState({ liked: false });
        }
    }

    // function to handle likes
    handleLikeClickHelper = (event) => {
        if (this.state.liked) {
            this.handleUnLikeClick(event);
            this.setState({ liked: false });
        } else {
            this.handleLikeClick(event);
            this.setState({ liked: true });
        }
    };
    handleLikeClick = async (event) => {
        let newClicks = this.state.likes + 1;
        this.setState({ likes: newClicks });
        const URI = `${API}api/meme/like`;
        const authToken = localStorage.getItem("authToken");
        if (!authToken) {
            alert("unauthorized");
        }
        const headers = {
            authorization: "Bearer " + authToken,
        };
        await axios
            .put(URI, { id: this.props.meme._id }, { headers: headers })
            .then((res) => {
                console.log("liked");
            })
            .catch((e) => {
                console.log("ERROR at updateMeme", e);
            });
    };
    handleUnLikeClick = async (event) => {
        let newClicks = this.state.likes - 1;
        this.setState({ likes: newClicks });
        const URI = `${API}api/meme/unlike`;
        const authToken = localStorage.getItem("authToken");
        if (!authToken) {
            alert("unauthorized");
        }
        const headers = {
            authorization: "Bearer " + authToken,
        };
        await axios
            .put(URI, { id: this.props.meme._id }, { headers: headers })
            .then((res) => {
                console.log("unliked");
            })
            .catch((e) => {
                console.log("ERROR at updateMeme", e);
            });
    };

    render() {
        let dateAndTime = new Date(this.props.meme.createdAt);
        let converted = dateAndTime.toString();
        let date = converted.slice(4, 15);
        let time = converted.slice(16, 24);
        return (
            <Grid.Row centered className="meme">
                <List.Item>
                    <List.Content>
                        <List.Header as="h2">
                            {this.props.meme.caption}
                        </List.Header>
                    </List.Content>
                    <Image
                        className="image"
                        style={{ width: "500px", height: "auto" }}
                        src={this.props.meme.url}
                    />
                    <List.Content>
                        <List.Description>
                            Submitted by{" "}
                            <b style={{ color: "yellow" }}>
                                {this.props.meme.username}
                            </b>{" "}
                            on <i>{date}</i> at <i>{time}</i>
                        </List.Description>
                    </List.Content>
                    <Button
                        as="div"
                        labelPosition="right"
                        onClick={this.handleLikeClickHelper}
                    >
                        <Button icon>
                            <Icon
                                name={
                                    this.state.liked ? "heart" : "heart outline"
                                }
                            />
                            {this.state.liked ? "Unlike" : "Like"}
                        </Button>
                        <Label as="a" basic pointing="left">
                            {this.state.likes}
                        </Label>
                    </Button>
                    {this.state.owner ? (
                        <Button
                            color="red"
                            onClick={() =>
                                this.props.deleteMeme(this.props.meme._id)
                            }
                        >
                            Delete
                        </Button>
                    ) : (
                        ""
                    )}
                    <Divider />
                </List.Item>
            </Grid.Row>
        );
    }
}
